import { Icon, Text, Tooltip, HStack, Stack } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import { Pressable, IPressableProps } from 'native-base';
import React from 'react';

import { TableHeadItemOrderBy } from '../../../../../../components/TableHead';
import { reportGeneratorTheme } from '../../../../constants/theme';

interface ReportGeneratorTableHeadItemProps extends IPressableProps {
  title: string;
  onPress?: () => void;
  value?: string;
  orderBy?: TableHeadItemOrderBy;
  tooltip?: string;
}

export const ReportGeneratorTableHeadItem: React.FC<ReportGeneratorTableHeadItemProps> = ({
  title,
  onPress,
  value,
  orderBy,
  tooltip,
  flex = 1,
  ...rest
}) => {
  const iconName =
    orderBy?.direction === 'asc' && value === orderBy?.value ? 'ArrowUp' : 'ArrowDown';
  const iconColor = value === orderBy?.value ? 'neutral.darkest' : 'neutral.light';

  return (
    <Pressable p={0} variant="unstyled" onPress={onPress} flex={flex} bg={rest.bg} maxW={rest.maxW}>
      <HStack space="inline.quarck">
        <Text
          variant="semibold"
          noOfLines={1}
          color={reportGeneratorTheme.table.columnHeaderColor}
          fontSize={Typography['fontsize.xs']}>
          {title}
        </Text>
        {!!value && (
          <Icon
            size="xxxxs"
            testID="report-generator-table-head-arrow"
            name={iconName}
            color={iconColor}
          />
        )}
        {!!tooltip && (
          <Tooltip label={tooltip} maxW="236px">
            <Stack>
              <Icon name="Info" size="xxxs" color="brand.primary.principal" />
            </Stack>
          </Tooltip>
        )}
      </HStack>
    </Pressable>
  );
};
